import { Alert, Col, DatePicker, Form, List, Row, message } from 'antd';
import moment from 'moment';
import React, { useEffect } from 'react';
import { getDocumentDetail, requestApproval, updateApproval } from 'services/session';
import { OwnDesktops, RequestInfo, UserSearchInput } from './components';
import { getErrorFields } from '../utils';

function DesktopDelete({ readOnly, form, id, onClose }) {
  const [user, setUser] = React.useState('');
  const [selectedVd, setSelectedVd] = React.useState('');
  const [userName, setUserName] = React.useState('');

  useEffect(() => {
    if (!id) {
      form.resetFields();
      const applicant = localStorage.getItem('userId');

      form.setFieldsValue({
        applicant,
        type: 'approval.types.delete-vd',
      });
      return;
    }

    getDocumentDetail(id).then((data) => {
      let approveDate = data?.approveDate;

      if (approveDate !== null) {
        approveDate = moment(approveDate);
      }
      form.setFieldsValue({
        ...data,
        approveDate,
        applyDate: moment(data.applyDate).format('YYYY-MM-DD HH:mm:ss'),
      });

      setUser(data?.user);
      setUserName(data?.userName);
    });
  }, [id]);

  return (
    <Form
      form={form}
      layout="horizontal"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
      onFinish={async ({ approveDate, ...fields }) => {
        const payload = {
          ...fields,
          contents: JSON.stringify(selectedVd),
          approveDate: approveDate?.format('YYYY-MM-DD HH:mm'),
        };
        try {
          const result = id ? await updateApproval(id, payload) : await requestApproval(payload);
          if (result.data.status === 'error') {
            const errors = getErrorFields(result.data.invalidParams);
            form.setFields(errors);
            return;
          }
          form.resetFields();
          onClose();
        } catch (e) {
          message.error(e);
        }
      }}
    >
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Alert
            showIcon
            type="warning"
            message={
              <List
                size="small"
                split={false}
                dataSource={[
                  '필요한 데이터를 모두 로컬PC로 다운로드 완료하셨나요?',
                  '승인완료 후 VD 사용이 불가능하므로, 신청하시기 전에 필요한 데이터를 모두 다운로드 받으신 후 신청하시기 바랍니다.',
                ]}
                renderItem={(item) => <List.Item style={{ padding: 4 }}>{item}</List.Item>}
              />
            }
          />
        </Col>
        <Col span={24}>
          <RequestInfo readOnly={readOnly} />
          <Form.Item label="신청 종류" name="type" required>
            VD 삭제
          </Form.Item>
          <Form.Item
            label="사용자(ID)"
            name="user"
            rules={[{ required: true, message: '필수 입력 항목 입니다.' }]}
          >
            <UserSearchInput
              readOnly1={readOnly}
              onSuccess={async (uid) => {
                // 처리
                setUser(uid);
              }}
              userName={userName}
            />
          </Form.Item>
          <Form.Item label="삭제 VD" name="contents" valuePropName="contents" required>
            <OwnDesktops
              title={false}
              bodyStyle={{ padding: 0 }}
              user={user}
              readOnly={readOnly}
              onSelect={(record) => {
                setSelectedVd(record);
              }}
              id={id}
            />
          </Form.Item>
          <Form.Item
            label="작업 희망 일시"
            name="approveDate"
            extra="작업 희망 일시를 설정하지 않거나 이미 경과된 경우 승인 시점에 처리됩니다."
            rules={[
              () => ({
                validator(_, value) {
                  if (value > moment() || !value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('현재보다 이전 시간은 설정할 수 없습니다.'));
                },
              }),
            ]}
          >
            <DatePicker
              showTime={{
                defaultValue: moment('00:00', 'HH:mm'),
                format: 'HH:mm',
              }}
              inputReadOnly={1}
              disabled={readOnly}
              placeholder=""
              disabledDate={(current) => current && current < moment().add(-1, 'day')}
              showNow={false}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
}

export default DesktopDelete;
